import PageContainer from 'components/common/PageContainer/PageContainer';
import SettingHeader from 'components/Settings/Components/SettingHeader/settingHeader';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { UserGroupsCreate } from 'components/Settings/Components/UserGroups/components/userGroupsCreate';

export const UserGroupsCreatePage = () => {
    useFullStoryPageView({ pageName: settingsConfig.userGroupsNew.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <SettingHeader
                    title={settingsConfig.userGroupsNew.title}
                    subTitle={'Add & edit User Groups'}
                    isBackArrow={true}
                />
            </HeaderWrapper>
            <MainContent>
                <UserGroupsCreate />
            </MainContent>
        </PageContainer>
    );
};
